import { StateCreator } from 'zustand';

import {
  handleAddSlackCommunication,
  handleClearSlackCommunicationsByWorkspaceId,
  handleDeleteSlackCommunication,
  handleDeleteSlackCommunications,
  handleGetSlackCommunicationById,
  handleSaveSlackChannels,
  handleSetLoading,
  handleSetThreadCommunications,
  handleUpdateSlackCommunication,
} from './handlers';
import { SlackCommunicationsStore } from './types';

export const createSlackCommunicationsSlice: StateCreator<
  SlackCommunicationsStore
> = (set, get) => {
  return {
    channels: [],
    directs: [],
    isLoading: false,
    startKey: null,
    setLoading: (isLoading) => handleSetLoading(set, isLoading),
    saveSlackChannels: (directs, channels, exclusiveStartKey) =>
      handleSaveSlackChannels(set, directs, channels, exclusiveStartKey),
    addSlackCommunication: (type, channelId, communication, isWebSocket) =>
      handleAddSlackCommunication(
        set,
        get,
        type,
        channelId,
        communication,
        isWebSocket,
      ),
    getSlackCommunicationById: (type, channelId, messageId) =>
      handleGetSlackCommunicationById(get, type, channelId, messageId),
    updateSlackCommunication: (type, channelId, messageId, updatedFields) =>
      handleUpdateSlackCommunication(
        set,
        get,
        type,
        channelId,
        messageId,
        updatedFields,
      ),
    deleteSlackCommunication: (type, channelId, messageId) =>
      handleDeleteSlackCommunication(set, get, type, channelId, messageId),
    deleteSlackCommunications: (type, channelId, messageIds) =>
      handleDeleteSlackCommunications(set, get, type, channelId, messageIds),
    setThreadCommunications: (type, channelId, communications) =>
      handleSetThreadCommunications(set, get, type, channelId, communications),
    clearSlackCommunicationsByWorkspaceId: (workspaceId) =>
      handleClearSlackCommunicationsByWorkspaceId(set, workspaceId),
    resetState: () =>
      set({
        channels: [],
        directs: [],
        isLoading: false,
        startKey: null,
      }),
  };
};
